<template>
  <div class="devInfo">
    <div class="content_wrapper">
      <div class="content__wrapper">
        <div class="info-header">
          <div class="title">{{companyInfo.companyName}}</div>
          <div class="add">详细地址：{{companyInfo.companyAddress}}</div>
          <div class="time">注册时间：{{companyInfo.registerTime}}</div>
          <div>
            <el-button type="primary">开发者信息</el-button>
            <el-button plain @click="goto('interfacemanage')" v-if="![6, 7].includes(devStatus)">接口管理</el-button>
            <el-button plain @click="goto('istatisticsCustomer')" v-if="![6, 7].includes(devStatus)">调用统计</el-button>
            <template v-if="valid('API_MANAGE_USER')">
              <span v-if="![6, 7].includes(devStatus)">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              <el-button plain @click="goto('modifyDeveloper')" v-if="![6, 7].includes(devStatus)">编辑客户</el-button>
              <!-- <el-button plain @click="gotoOpenRenew" v-if="devStatus == '1' || devStatus == '3'">批量开通</el-button> -->
            </template>
          </div>
          <div class="user">
            <img v-if="devStatus == '2'" src="../../../assets/images/icon/on-use.png"/><span v-if="devStatus == '2'" style="color:#996e52;">正式用户</span>
            <img v-if="devStatus == '1'" src="../../../assets/images/icon/try.png"/><span v-if="devStatus == '1'" style="color:#479efe;">试用用户</span>
            <img v-if="devStatus == '3'" src="../../../assets/images/icon/outDate.png"/><span v-if="devStatus == '3'" style="color:#666;">过期用户</span>
            <img v-if="devStatus == '0'" src="../../../assets/images/icon/invalid.png"/><span v-if="devStatus == '0'" style="color:#878787;">未生效用户</span>
            <img v-if="devStatus == '4'" src="../../../assets/images/icon/forbiden.png"/><span v-if="devStatus == '4'" style="color:#ed4a3a;">禁用用户</span>
            <img v-if="devStatus == '5'" src="../../../assets/images/icon/other.png"/><span v-if="devStatus == '5'" style="color:#4a6589;">其他用户</span>
            <img v-if="devStatus == '6'" src="../../../assets/images/icon/other.png"/><span v-if="devStatus == '6'" style="color:#878787;">待审核</span>
            <img v-if="devStatus == '7'" src="../../../assets/images/icon/other.png"/><span v-if="devStatus == '7'" style="color:#ed4a3a;">审核拒绝</span>
          </div>
        </div>
        <div style="background:white;margin-top:20px;overflow: hidden;">
          <div class="accountinfo info_item">
            <div style="font-size: 18px;font-weight: bold;margin-top:10px;">开发者账户信息</div>
            <div class="info_form">
              <table width="100%" class="info-table">
                <tr>
                  <td class="table-title">用户ID：</td>
                  <td>{{companyInfo.id}}</td>
                  <td class="table-title">账号：</td>
                  <td>{{companyInfo.mobile}}</td>
                </tr>
                <tr>
                  <td class="table-title">clientId：</td>
                  <td>{{companyInfo.clientId}}</td>
                  <td class="table-title">clientSecret：</td>
                  <td>{{companyInfo.clientSecret}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="accountinfo info_item">
            <div style="font-size: 18px;font-weight: bold;margin-top:10px;">联系人</div>
            <div class="info_form">
              <table width="100%" class="info-table">
                <tr>
                  <td class="table-title">业务联系人：</td>
                  <td>{{companyInfo.businessContact}}</td>
                  <td class="table-title">手机号码：</td>
                  <td>{{companyInfo.contactNumber}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="accountinfo info_item">
            <div style="font-size: 18px;font-weight: bold;margin-top:10px;">公司信息</div>
            <div class="info_form">
              <table width="100%" class="info-table">
                <tr>
                  <td class="table-title">公司名称：</td>
                  <td>{{companyInfo.companyName}}</td>
                  <td class="table-title">公司网址：</td>
                  <td>{{companyInfo.companyWebsiteAddress || '暂无'}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="accountinfo info_item">
            <div style="font-size: 18px;font-weight: bold;margin-top:10px;">营业执照</div>
            <div>
              <div style="text-align:center;" v-if="companyInfo.businessLicenseUrl">
                <img style="width:300px;height:300px" :src="companyInfo.businessLicenseUrl"/>
              </div>
              <div v-else style="text-align:center;margin: 30px 0;">
                暂未上传
              </div>
            </div>
          </div>
          <div class="accountinfo info_item" v-if="![6, 7].includes(devStatus)">
            <div style="font-size: 18px;font-weight: bold">开通历史</div>
            <div>
              <el-table class="resource-class" :data="history.content" header-row-class-name="header-row-class-name" border style="width: 100%">
                <el-table-column label="ID" prop="id" align="center"></el-table-column>
                <el-table-column label="操作类型" prop="optional" align="center"></el-table-column>
                <el-table-column label="开通类型" prop="type" align="center">
                  <template slot-scope="scope">
                    {{scope.row.type == 1 ? "按时段" : "按数量"}}
                  </template>
                </el-table-column>
                <el-table-column label="操作记录" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.apiResourceDto && scope.row.apiResourceDto.resourceType === 1">普通</span><span v-if="scope.row.apiResourceDto && scope.row.apiResourceDto.resourceType === 2">精品</span><span v-if="scope.row.apiResourceDto">{{scope.row.apiResourceDto.name}}接口:</span>
                    <span v-if="scope.row.type == 1">{{scope.row.startTime + ' 至 ' + scope.row.endTime}}</span>
                    <span v-if="scope.row.type == 2">
                      {{'(接口调用限制:'+scope.row.invokeLimit + "次，接口下载数量:"+ scope.row.downloadLimit + "次)" }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作时间" prop="createTime" align="center"></el-table-column>
              </el-table>
              <div style="text-align:center;margin-top:10px;">
                <el-pagination
                  background
                  @current-change="fetchDevResourceHistory"
                  :current-page.sync="pageNumber"
                  :page-size="pageSize"
                  layout="total, prev, pager, next"
                  :total="total">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import types from '@/vuex/mutation-types'
import { mapMutations, mapGetters } from 'vuex'
import devService from '@/service/devService'
import { COMMON_UPLOAD_API } from '@/resource/index'
import adminMixin from '@/mixins/adminMixin'

export default {
  mixins: [adminMixin],
  data () {
    return {
      loading: false,
      height: this.SysConstant.winHeight - 450,
      fileList: [],
      COMMON_UPLOAD_API: COMMON_UPLOAD_API,
      headers: {
        Authorization: this.$cookie.get('token')
      },
      history: {},
      pageNumber: 0,
      pageSize: 10,
      total: 0,
      devStatus: '',
      rules: {
        companyName: [
          {required: true, message: '请输入公司名称', trigger: ['blur', 'change']}
        ],
        businessContact: [
          {required: true, message: '请输入联系人', trigger: ['blur', 'change']}
        ],
        contactNumber: [
          {required: true, message: '请输入联系电话', trigger: ['blur', 'change']},
          {validator: this.$rules.telephoneNumber, trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
    this.uploadText = '更新营业执照'
    this.fetchDevResourceHistory()
    this.getDeveloperStatus()
  },
  computed: {
    ...mapGetters(['companyInfo'])
  },
  methods: {
    ...mapMutations({
      commitCompanyInfo: types.COMPANY_INFO
    }),
    // 获取开发者状态
    async getDeveloperStatus () {
      try {
        this.devStatus = await devService.getDeveloperStatus({developerId: this.companyInfo.id})
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 续费开通
    gotoOpenRenew () {
      this.$router.push({name: 'openAndRenew', query: {id: this.companyInfo.id}})
    },
    // 跳转页面
    goto (name) {
      this.$router.push({name: name})
    },
    // 查询用户开通历史
    async fetchDevResourceHistory () {
      try {
        this.history = await devService.fetchDevResourceHistory({userId: this.companyInfo.id, pageNumber: this.pageNumber, pageSize: this.pageSize, isClient: 0})
        this.total = this.history.totalElements
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 加载初始化数据
    submit () {
      this.loading = true
      this.$refs.companyInfo.validate(async valid => {
        // 验证通过
        if (valid) {
          try {
            await devService.devModifyInfo(this.companyInfo.id, this.companyInfo)
            // 同步更新Vuex
            this.commitCompanyInfo(this.companyInfo)
            this.$message.success(this.SysConstant.success)
            this.loading = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
      })
      this.loading = false
    },
    backLastPage () {
      this.$router.push({name: 'devmanage'})
    },
    handleRemove (file, fl) {
      this.fileList = []
      this.companyInfo.businessLicenseUrl = ''
    },
    handleSuccess (response, file, fileList) {
      this.fileList = []
      this.fileList.push(file)
      this.$set(this.companyInfo, 'businessLicenseUrl', response.data)
    }
  }
}
</script>
<style scoped>

  .devInfo {
    padding-top: 10px;
    overflow-y: auto;
  }
  .devInfo .content_wrapper{

  }

  .devInfo .toolbar .el-select {
    width: 130px;
  }
  .devInfo .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .devInfo .content_wrapper{
    width: 100%;
    height:100%;
  }
  .devInfo .content_wrapper .content__wrapper .info-header{
    background: #ffffff;
    padding: 20px 24px;
    position: relative;
    color: #333;
  }
  .devInfo .content_wrapper .content__wrapper .info-header .title{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .devInfo .content_wrapper .content__wrapper .info-header .add,.devInfo .content_wrapper .content__wrapper .info-header .time{
    font-size: 14px;
    color: gray;
    margin-bottom: 20px;
    max-width: 900px;
  }
  .devInfo .content_wrapper .content__wrapper .info-header .user span{
    position: absolute;
    right: 162px;
    top: 85px;
    font-size: 18px;
    font-weight: bold;
  }
  .devInfo .content_wrapper .content__wrapper .info-header .user img{
    position: absolute;
    right: 246px;
    top: 79px;
  }
  .devInfo   .content_wrapper .info_item{
    padding-left: 24px;
    padding-bottom: 10px;
    padding-right: 20px;
  }
  .devInfo .content_wrapper .info_form {
    padding-left: 10px;
    padding-bottom: 10px;
    padding-right: 10px;
    border-bottom: 1px solid #eeeeee;
    overflow-y: auto;
  }
  .devInfo .content_wrapper .info_form .info-table{
    margin-top: 10px;
    border-color:#EBEEF5 ;
  }
  .devInfo .content_wrapper .info_form .info-table .table-title{
    background-color: #F2F2F2;
    width: 10%;
  }
  .devInfo .content_wrapper .info_form .info-table td{
    height: 40px;
    width: 40%;
    padding-left: 20px;
    border:1px solid #EBEEF5;
  }
  .devInfo   .content_wrapper  .info{
    height: 40px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
    vertical-align: middle;
  }
  .devInfo .content_wrapper .info div{
    display: inline-block;
  }
  .devInfo .content_wrapper .info  .info_label{
    width: 30%;
    float: left;
    text-align: right;
  }
  .devInfo   .content_wrapper .info .info_content{
    padding-left: 15px;
    text-align: left;
    float: left;
  }
  .devInfo .content__wrapper .companyInfo .el-input{
    width: 80%;
  }
  .devInfo img.businessLicense{
    height: 40px;
    line-height: 40px;
    width: 40px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    cursor: pointer;
  }

</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/dev-info/index.vue